<div [ngSwitch]="line.type">
  <div *ngSwitchCase="eJSON_LINE_TYPE.eSETTING_STD">
    <app-line-setting [line]="line"></app-line-setting>
  </div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eMEASUREMENT">
    <app-line-measurement [line]="line"></app-line-measurement>
  </div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eBUTTON">
    <app-line-button [line]="line"></app-line-button>
  </div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eSTATUS">
    <app-line-status [line]="line"></app-line-status>
  </div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eSETTING_TEXT">
    <app-line-setting-text [line]="line"></app-line-setting-text>
  </div>

  <div *ngSwitchCase="eJSON_LINE_TYPE.eCOMPLEX"></div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eSCALE"></div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eDISPLAY_TYPE"></div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eCONSTANT_VALUE"></div>
  <div *ngSwitchCase="eJSON_LINE_TYPE.eCARD_BRANCH"></div>



  <div *ngSwitchCase="255">
    <small>last item marker</small>
  </div>
  <div *ngSwitchDefault>
    Line component for this type not defined
  </div>
</div>

